/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusThemenbereichOptionDto } from '../../models/lexplus-themenbereich-option-dto';

export interface ThemenbereicheControllerGetThemenbereicheDropdownOptionsV1$Params {
  funktionIds?: Array<number>;
  standortIDs?: Array<number>;
  onlyAssigned?: boolean;
}

export function themenbereicheControllerGetThemenbereicheDropdownOptionsV1(http: HttpClient, rootUrl: string, params?: ThemenbereicheControllerGetThemenbereicheDropdownOptionsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusThemenbereichOptionDto>>> {
  const rb = new RequestBuilder(rootUrl, themenbereicheControllerGetThemenbereicheDropdownOptionsV1.PATH, 'get');
  if (params) {
    rb.query('funktionIds', params.funktionIds, {});
    rb.query('standortIDs', params.standortIDs, {});
    rb.query('onlyAssigned', params.onlyAssigned, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusThemenbereichOptionDto>>;
    })
  );
}

themenbereicheControllerGetThemenbereicheDropdownOptionsV1.PATH = '/v1/themenbereiche/dropdown-options';
